'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import useSessionStorage from "@/app/hooks/sessionStorage"

export default function Page() {
  const router = useRouter()
  const [data] = useSessionStorage("data", null)
  const [token] = useSessionStorage("token", null)

  useEffect(() => {
    // Se non ho dati di sessione, mando al login
    if (!data || !token) {
      router.push('/login')
      return
    }
    // Se sono admin mando in /admin, altrimenti /home
    if (data.user?.isAdmin) {
      router.push('/admin')
    } else {
      router.push('/home')
    }
  }, [data, token, router])

  // Finché non arriva data/token, mostra un placeholder (o nulla)
  return null
}